export default {
    pageTitle: 'MY PROFILE',
    title: {
        blank: 'Settings',
        name: '<span class="primary--text">{firstName} {lastName}</span> / Settings'
    }
}
